const URL = 'https://checkoutshopper-{environment}.cdn.adyen.com/checkoutshopper/sdk/6.3.0/';

export { URL };
